import { render, staticRenderFns } from "./EnglishLanguageSupport-EN.vue?vue&type=template&id=837d2464&scoped=true"
import script from "./EnglishLanguageSupport-EN.vue?vue&type=script&lang=js"
export * from "./EnglishLanguageSupport-EN.vue?vue&type=script&lang=js"
import style0 from "./els-css/typography.gotham.css?vue&type=style&index=0&id=837d2464&prod&lang=css&scoped=true&external"
import style1 from "./EnglishLanguageSupport-EN.vue?vue&type=style&index=1&id=837d2464&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837d2464",
  null
  
)

export default component.exports